import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';
import('./pb-specifier-header-v4.css');

const pbSpecifierHeaderV4 = {
    init: function(){
        $('.pb-specifier-header-v4').find('.previous-cta').on("click",function(){
            $(this).parent().addClass("show");
            return false;
        });
        if ($('.pb-specifier-header-v4 .splide').length > 0) {
            new Splide( '.pb-specifier-header-v4 .splide' , {
                pagination: false,
                arrows: false,
                autoWidth: true,
                autoHeight: true,
                snap: true,
                drag: true,
                gap: "30px",
                brakpoints: {
                    1920: {
                        drag: false,
                    },
                    1432: {
                        gap: "14px",
                        drag: false,
                    },
                    1136: {
                        drag: true,
                    }
                }
            } ).mount();
        }
    }
};
window.loadedComponents.push({ component: 'pb-specifier-header-v4', init: pbSpecifierHeaderV4.init});

export default() => {
    pbSpecifierHeaderV4.init();
}